import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import GranteeProfileInfo from '../../../widgets/granteeProfileInfo/GranteeProfileInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchema } from '../../../redux/actions/granteeProfileInfoForDirector'
import { startLoading, doneLoading } from '../../../utils/loading'

export default function GranteeProfileInfoForDirector() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchema(projectId)
      setSchema(_schema)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <GranteeProfileInfo schema={schema.forms?.granteeProfile} />
      <br />
    </SidebarProposal>
  )
}
